module.exports = __webpack_public_path__ + "static/newwords-99a79ebd98a5ee9104ce5563a19eec44.mp4";